define('constants/videoPlayerConstants',[], function() {
    return Object.freeze({
        defaultTotalTime: "0:00",
        firstMilliSecond: 0.001
    });
});

